import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { isTeamTabRequested, type TeamTabParam } from "./teamTabDeepLink";

/**
 * Applies `?{param}=true` once: opens the tab through `openTab`, then strips the param so Back does not re-select
 * it over the user's own choice. `openTab` must be stable (it is an effect dependency).
 *
 * A viewer who cannot see that tab lands on Team through the page's own fallback.
 */
export const useTeamTabDeepLink = (param: TeamTabParam, openTab: () => void) => {
	const [searchParams, setSearchParams] = useSearchParams();
	useEffect(() => {
		if (!isTeamTabRequested(searchParams, param)) return;
		openTab();
		// Updater form, not the snapshot: the Team filters write the same query string in the same tick.
		setSearchParams(
			(current) => {
				const remaining = new URLSearchParams(current);
				remaining.delete(param);
				return remaining;
			},
			{ replace: true },
		);
	}, [searchParams, setSearchParams, param, openTab]);
};
